import type {
  RouteLocationTo,
  RouteLocationParam,
  Router,
} from 'src/types/router';

import * as React from 'react';
import {Link, type RerouterLocation} from 'src/rerouter';
import {useSelector} from 'react-redux';


const ChatLink = ({
  to,
  toOutside,
  hideInExtension,
  ...props
}: Readonly<{
  to?: RouteLocationTo;
  toOutside?: boolean;
  hideInExtension?: boolean;
}>) => {
  // @ts-expect-error - TS2339 - Property 'env' does not exist on type 'DefaultRootState'.
  const {context, ver, channel} = useSelector((state) => state.env.query);
  const isExtension = context === 'chrome-extension';
  let linkTo = to;
  linkTo = (location: RerouterLocation) => {
    let intendedLocation;
    if (typeof to === 'string') {
      intendedLocation = {pathname: to};
    } else if (typeof to === 'function') {
      intendedLocation = to(location);
    } else {
      intendedLocation = to;
    }

    return {
      ...(intendedLocation && typeof intendedLocation === 'object'
        ? intendedLocation
        : {}),
      query: {
        ...(location?.query?.inbox_filter && {
          inbox_filter: location.query.inbox_filter,
        }),
        ...(location?.query?.owned_by && {owned_by: location.query.owned_by}),
        // @ts-expect-error - TS2339 - Property 'query' does not exist on type 'RouteLocationParam'.
        ...(intendedLocation?.query || null),
        ...(isExtension ? {context, ver, channel} : {}),
      },
    };
  };

  if (isExtension) {
    if (hideInExtension) {
      return null;
    }

    if (toOutside) {
      // @ts-expect-error - TS2322 - Type 'RouteLocationTo | undefined' is not assignable to type 'string | undefined'.
      return <a {...props} href={to} target="_blank" rel="noopener" />;
    }
  }

  return <Link {...props} to={linkTo} handleExtension={isExtension} />;
};

export default ChatLink;

export function pushChatLocation(
  router: Router,
  newLocation: string | RouteLocationParam,
  browserContext: string = '',
) {
  const {context, ver} = router.location.query;
  const intendedLocation =
    typeof newLocation === 'string'
      ? {pathname: newLocation, query: {}}
      : newLocation;
  if (context) {
    intendedLocation.query = {...intendedLocation.query, context, ver};
  }
  if (browserContext === 'chrome-extension') {
    window.open(intendedLocation.pathname, '_blank');
    return;
  }
  router.push(intendedLocation);
}

export function replaceChatLocation(
  router: Router,
  newLocation: string | RouteLocationParam,
) {
  const intendedLocation = prepareChatLocation(router, newLocation);

  router.replace(intendedLocation);
}

const prepareChatLocation = (
  router: Router,
  newLocation: RouteLocationParam | string,
) => {
  const {context, ver} = router.location.query;
  const intendedLocation =
    typeof newLocation === 'string'
      ? {pathname: newLocation, query: {}}
      : newLocation;
  if (context) {
    intendedLocation.query = {...intendedLocation.query, context, ver};
  }

  return intendedLocation;
};
